// removed by extract-text-webpack-plugin
module.exports = {"this":"_2kHCEbsJhaHFNBHCrgjI8s","award":"puCl-yeVLivCwqIdqZizQ","arrow":"Y0FxQrBHbj7VIrwmj2RXj"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/ui/Draw/CircleZhuanPan.scss
// module id = 934
// module chunks = 12